import { TMessage } from "./tt";
import { TMessageKey } from "./types.gen";

export enum Language {
  EN = "en",
  NO = "no",
  SV = "sv",
}

const languages = new Set<string>(Object.values(Language));

export const languageLabels: { [key in Language]: TMessageKey } = {
  [Language.EN]: "language.en",
  [Language.NO]: "language.no",
  [Language.SV]: "language.sv",
};

export const languageLabel = (l: Language): TMessage => ({ key: languageLabels[l] });

export const isSupportedLanguage = (lang?: unknown): lang is Language =>
  typeof lang === "string" && languages.has(lang);

export const supportedBackendLanguages: Language[] = [Language.EN, Language.NO];

export const toSupportedLanguage = (lang: string | undefined): Language => {
  return toSupportedLangOrUndefined(lang) ?? DEFAULT_LANG;
};

export const toSupportedLangOrUndefined = (lang: string | undefined): Language | undefined => {
  lang = (lang ?? "").toLocaleLowerCase();
  if (lang.indexOf("-") > 0) {
    lang = lang.split("-")[0];
  }
  switch (lang) {
    case "en":
      return Language.EN;
    case "no":
    case "nn":
    case "nb":
      return Language.NO;
    case "sv":
      return Language.SV;
    default:
      return undefined;
  }
};

export const DEFAULT_LANG = Language.EN;

export type TranslationDirection = {
  from: Language;
  to: Language;
};
